var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49898 13.4721C2.65898 13.4721 2.69098 13.4561 2.83498 13.4241L5.71498 12.8481C6.01898 12.7681 6.32298 12.6241 6.56298 12.3841L13.539 5.40809C14.611 4.33609 14.611 2.49609 13.539 1.42409L12.947 0.800094C11.875 -0.271906 10.019 -0.271906 8.94698 0.800094L1.97098 7.79209C1.74698 8.01609 1.58698 8.33609 1.50698 8.64009L0.898981 11.5521C0.818981 12.0961 0.978981 12.6241 1.36298 13.0081C1.66698 13.3121 2.11498 13.4721 2.49898 13.4721ZM3.04298 8.94409L10.019 1.95209C10.483 1.48809 11.331 1.48809 11.779 1.95209L12.387 2.56009C12.931 3.10409 12.931 3.87209 12.387 4.40009L5.42698 11.3921L2.46698 11.8881L3.04298 8.94409Z",
    fill: "#838383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4744 14.4639H1.66644C1.20244 14.4639 0.898438 14.7679 0.898438 15.2319C0.898438 15.6959 1.28244 15.9999 1.66644 15.9999H13.4104C13.8744 15.9999 14.2584 15.6959 14.2584 15.2319C14.2424 14.7679 13.8584 14.4639 13.4744 14.4639Z",
    fill: "#838383"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.531e06e6ce97f34582239b76356fefdd.svg";
export { ForwardRef as ReactComponent };